/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Popover,
  Select,
  Stack,
  TextField,
  TablePagination,
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  CircularProgress,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { DataGrid, GridToolbarExport } from '@mui/x-data-grid';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import './styles.css';
import _ from 'lodash';
import moment from 'moment';

import ModalComponent from '../Modal';

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      columns: [],
      open: false,
      anchorEl: null,
      language: '',
      isOpenVATPopup: false,
      isLoading: false,
      selectionModel: [],
    };
  }

  async componentDidMount() {
    const { data, columnsConfig } = this.props;
    let rows = [];
    rows = data.map((o, index) => {
      let row = { id: index };

      columnsConfig.forEach(k => {
        row = {
          ...row,
          [k.field]: o[k.key],
        };
      });
      return row;
    });
    this.setState({
      rows,
      columns: columnsConfig,
    });
    this.props.saveFilterData(rows);
  }

  static getDerivedStateFromProps(props, state) {
    const { rows, columns } = state;
    if (props.language !== state.language || props.data !== rows) {
      const { data, columnsConfig, language } = props;
      let rowsNew = [];
      rowsNew = data.map((o, index) => {
        let row = { id: index };
        columnsConfig.forEach(k => {
          row = {
            ...row,
            [k.field]: o[k.key],
          };
        });
        return row;
      });
      return {
        rows: rowsNew,
        columns: columnsConfig,
        language,
      };
    }
    this.props.saveFilterData(rows);
    return {
      rows,
      columns,
    };
  }

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  handlePrivacyClick = () => {
    this.setState({ isOpenVATPopup: true });
  };

  handleClose = () => {
    this.setState({ isOpenVATPopup: false });
  };

  onFilterApply = () => {
    const { rows } = this.state;
    const { filterField, searchTerm } = this.props;

    const filteredRows = rows.filter(r => {
      if (Array.isArray(r[filterField])) {
        return r[filterField].includes(searchTerm);
      }
      return false;
    });

    this.setState({ open: false });

    const selectedCol = this.props.columnsConfig.find(c => c.field === filterField);
    this.props.saveFilterData(filteredRows, selectedCol, searchTerm);
  };

  onFilterClear = () => {
    this.setState({ open: false });
    this.props.clearFilter();
  };

  handleFieldsChange = e => {
    const { saveFilterFields } = this.props;
    const val = e.target.value;
    const selectedCol = this.props.columnsConfig.find(c => c.field === val);
    if (selectedCol.inputType === 'Date') {
      const data = {
        showDateFilter: true,
        searchTerm: `datetime'${moment(new Date()).format('YYYY-MM-DD')}T00:00:00'`,
      };
      saveFilterFields(data);
    } else if (selectedCol.inputType === 'Float') {
      const data = {
        searchTerm: ``,
        showPriceFilter: true,
        showDateFilter: false,
        showMultiFilter: false,
      };
      saveFilterFields(data);
    } else if (selectedCol.inputType === 'MultiSelect') {
      const data = {
        searchTerm: ``,
        showMultiFilter: true,
        showDateFilter: false,
        showPriceFilter: false,
      };
      saveFilterFields(data);
    } else {
      saveFilterFields({
        showDateFilter: false,
        showPriceFilter: false,
        showMultiFilter: false,
      });
    }
    const data = {
      filterField: val,
      searchTerm: '',
    };
    saveFilterFields(data);
  };

  handleDateChange = newValue => {
    const { saveFilterFields } = this.props;
    if (!_.isNaN(newValue.$D)) {
      const fDate = `datetime'${moment(newValue.$d).format('YYYY-MM-DD')}T00:00:00'`;
      const data = {
        searchTerm: fDate,
        selectedDate: newValue,
      };
      saveFilterFields(data);
    }
  };

  handleDownloadClick = async () => {
    this.setState({ isLoading: true });
    await this.props.loadFullData();
    this.setState({ isLoading: false });
  };

  CustomToolbar = () => {
    const { selectionModel } = this.state;
    const {
      columnsConfig,
      t,
      filterField = '',
      searchTerm = '',
      saveFilterFields = () => {},
      selectedDate = null,
      showDateFilter = false,
      showMultiFilter = false,
      multiSelectData = [],
      handleMultiSelection = () => {},
      showAddToCart = false,
      showVat = false,
    } = this.props;
    const { isOpenVATPopup, isLoading } = this.state;
    const id = this.state.open ? 'simple-popover' : undefined;

    const filteredColumns = columnsConfig.filter(col => !col.hideFromFilter);

    const handleAddToCart = () => {
      this.props.handleAddToCart(selectionModel);
      this.setState({ selectionModel: [] });
    };

    return (
      <Stack direction="row" justifyContent="space-between" px={2}>
        <IconButton onClick={() => this.setState({ open: true })}>
          <FilterAltOutlinedIcon sx={{ margin: 1 }} />
        </IconButton>
        <Popover
          id={id}
          open={this.state.open}
          onClose={this.handleRequestClose}
          anchorReference="anchorPosition"
          anchorPosition={{ top: 280, left: 100 }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          anchorEl={this.state.anchorEl}
        >
          <Stack sx={{ mx: 2, my: 3, width: 200 }}>
            <Stack spacing={2} p={1}>
              <FormControl fullwidth>
                <InputLabel id="demo-simple-select-label">
                  {t('libraryScreenTranslations:COLUMNS')}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filterField}
                  onChange={this.handleFieldsChange}
                  label={t('libraryScreenTranslations:COLUMNS')}
                >
                  {filteredColumns.map((item, index) => (
                    <MenuItem value={item.field} key={index.toString()}>
                      {item.headerName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {showDateFilter && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={t('libraryScreenTranslations:VALUE')}
                    value={selectedDate}
                    onChange={this.handleDateChange}
                    renderInput={params => <TextField {...params} />}
                  />
                </LocalizationProvider>
              )}
              {showMultiFilter && (
                <Stack sx={{ overflowY: 'auto', height: 100, pl: 1 }}>
                  {multiSelectData &&
                    multiSelectData.map((d, dIndex) => (
                      <FormControlLabel
                        key={dIndex.toString()}
                        control={
                          <Checkbox
                            key={d.id}
                            checked={d.checked}
                            // disabled={isProductsLoading}
                            onChange={() => {
                              handleMultiSelection(d);
                            }}
                          />
                        }
                        label={
                          <Typography sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}>
                            {d.label}
                          </Typography>
                        }
                        sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
                      />
                    ))}
                </Stack>
              )}

              {!showDateFilter && !showMultiFilter && (
                <FormControl>
                  <TextField
                    label={t('libraryScreenTranslations:VALUE')}
                    value={searchTerm}
                    variant="outlined"
                    onChange={e => saveFilterFields({ searchTerm: e.target.value })}
                  />
                </FormControl>
              )}
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Button
                variant="text"
                onClick={this.onFilterClear}
                disabled={searchTerm === '' || filterField === ''}
              >
                {t('libraryScreenTranslations:CLEAR')}
              </Button>
              <Button
                variant="text"
                onClick={this.onFilterApply}
                disabled={searchTerm === '' || filterField === ''}
              >
                {t('libraryScreenTranslations:APPLY')}
              </Button>
            </Stack>
          </Stack>
        </Popover>
        {/* <Tooltip title="Export">
          <GridToolbarExport classes={{ root: 'Custom-MuiButton-root' }} />
        </Tooltip> */}
        <Stack direction="row" justifyContent="flex-end" alignItems="center">
          {showAddToCart && (
            <Stack>
              <Button
                variant="contained"
                color="primary"
                disabled={selectionModel.length === 0}
                onClick={handleAddToCart}
                sx={{
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  mr: 2,
                }}
              >
                {t('uploadScreenTranslations:ADD_TO_CART')}
              </Button>
            </Stack>
          )}
          {showVat && (
            <>
              <Button
                variant="text"
                color="primary"
                onClick={this.handlePrivacyClick}
                sx={{
                  fontSize: { xs: 12, md: 14 },
                  textAlign: 'end',
                }}
              >
                VAT Regulation
              </Button>
              <ModalComponent isOpen={isOpenVATPopup} onClose={this.handleClose} />
            </>
          )}
          {isLoading ? (
            <CircularProgress size={20} />
          ) : (
            <IconButton onClick={this.handleDownloadClick}>
              <FileDownloadOutlinedIcon color="primary" />
            </IconButton>
          )}
        </Stack>
      </Stack>
    );
  };

  render() {
    const { columns, selectionModel } = this.state;
    const {
      showExport = false,
      checkboxSelection = false,
      isRowSelectable = () => true,
      onSelectionModelChange = () => {},
      onRowClick = () => {},
      handleOnCellClick = () => {},
      listCount = null,
      page,
      onPageChange = () => {},
      rowsPerPage,
      filteredData,
      // loadFullData,
      handleAddToCart = () => {},
    } = this.props;
    return (
      <>
        <Box>
          <DataGrid
            onRowClick={onRowClick}
            autoHeight
            rows={filteredData}
            columns={columns.filter(col => !col.hideFromHeader)}
            rowCount={listCount}
            checkboxSelection={checkboxSelection}
            isRowSelectable={isRowSelectable}
            onSelectionModelChange={newSelection => {
              this.setState({ selectionModel: newSelection });
              onSelectionModelChange(newSelection);
            }}
            selectionModel={selectionModel}
            components={
              showExport
                ? {
                    Toolbar: this.CustomToolbar,
                  }
                : {}
            }
            pagination
            // hideFooterPagination
            disableColumnFilter
            disableColumnSelector
            disableColumnMenu
            rowsPerPageOptions={[]}
            hideFooter
            onCellClick={handleOnCellClick}
          />
          <Stack direction="row" justifyContent="end">
            <TablePagination
              component="div"
              count={listCount !== null ? listCount : 0}
              page={page}
              onPageChange={(event, newPage) => {
                this.setState({ selectionModel: [] });
                onPageChange(event, newPage);
              }}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[]}
            />
          </Stack>
        </Box>
      </>
    );
  }
}

export default Table;
